export class Login {
	options = {
		companyLoginField: '#company-login',
		companyLoginError: '#company-login-error',
		companyLoginButton: '#company-login-button',
	};

	constructor(options) {
		this.options = $.extend(this.options, options);
		this.init();
	}

	init() {
		const loginField = $(this.options.companyLoginField);
		const loginButton = $(this.options.companyLoginButton);
		const errorLabel = $(this.options.companyLoginError);

		// Initially disable the button
		loginButton.prop('disabled', true);

		// Allow only specific characters
		loginField.on('keypress', (event) => /^[a-z0-9\-_ ]$/i.test(event.key));

		// Sanitize input and enable/disable button
		loginField.on('input', function () {
			const cleanedValue = $(this)
				.val()
				.replace(/[^a-z0-9\-_ ]/ig, '')
				.trim();

			$(this).val(cleanedValue);
			loginButton.prop('disabled', cleanedValue.length === 0);

			// Remove aria-invalid if user starts typing again
			if (cleanedValue.length > 0) {
				$(this).removeAttr('aria-invalid');
				errorLabel.hide().text('');
			}
		});

		// Handle button click
		loginButton.on('click', () => {
			const loginValue = loginField.val().trim();
			errorLabel.text('').hide();

			if (!loginValue) {
				this.showError(loginField, errorLabel, _t('Please enter your company login.'));
				return;
			}

			$.get(
				`${this.options.path.loginCompanyLink}/${loginValue}`,
				(result) => {
					if (result.success) {
						location.href = result.result;
					} else {
						this.showError(loginField, errorLabel, _t(result.error));
					}
				},
				'json'
			);
		});
	}

	/**
	 * Show accessible error message and focus input
	 */
	showError(input, errorLabel, message) {
		errorLabel.text(message).show();
		input.attr('aria-invalid', 'true').focus();
	}
}
